import { render, staticRenderFns } from "./PinVerification.vue?vue&type=template&id=34ec13c1&"
import script from "./PinVerification.vue?vue&type=script&lang=js&"
export * from "./PinVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports